import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 6A73A89B-2C02-4DB5-89DF-0449750171BC
 * name google-glass
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-glass.svg
 * tags
 * - Brand / Logo 
 */
export const GoogleGlassIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M16.75 18H15.25V8.9L6.72 18H4.66L15.45 6.5C15.66 6.26 16 6.19 16.27 6.3C16.56 6.42 16.75 6.69 16.75 7V18Z" /></>, 'GoogleGlassIcon');
export default GoogleGlassIcon